// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"f89224cc","453":"5d2c1993","546":"a0474152","809":"8bd5462e"}[chunkId] + ".chunk.js";
};